import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface DeleteCellDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  contentCount: number;
}

export const DeleteCellDialog: React.FC<DeleteCellDialogProps> = ({
  open,
  onOpenChange,
  onConfirm,
  contentCount,
}) => {
  const handleConfirm = () => {
    onConfirm();
    onOpenChange(false);
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete this cell?</AlertDialogTitle>
          <AlertDialogDescription>
            {contentCount > 1 ? (
              <>This will delete <strong>{contentCount} blocks</strong> inside this cell. This action cannot be undone.</>
            ) : contentCount === 1 ? (
              <>This cell contains content. Deleting it will remove the content. This action cannot be undone.</>
            ) : (
              <>Are you sure you want to delete this empty cell?</>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={handleConfirm} className="bg-destructive text-destructive-foreground hover:bg-destructive/90">
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
